var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdministrativeDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#DFF5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.88 34.8a1.02 1.02 0 01-1.08-1.08 2.16 2.16 0 00-2.16-2.16h-7.56A1.02 1.02 0 0112 30.48v-16.2a1.02 1.02 0 011.08-1.08h6.48a5.5 5.5 0 014.32 2.16 5.5 5.5 0 014.32-2.16h6.48a1.02 1.02 0 011.08 1.08v16.2a1.02 1.02 0 01-1.08 1.08h-7.56a2.16 2.16 0 00-2.16 2.16 1.02 1.02 0 01-1.08 1.08zm4.32-19.44a3.18 3.18 0 00-3.24 3.24v11.34c.67-.34 1.4-.53 2.16-.54h6.48V15.36h-5.4zm-14.04 0V29.4h6.48c.75.01 1.5.2 2.16.54V18.6a3.18 3.18 0 00-3.24-3.24h-5.4z",
    fill: "#01B0BB"
  })));
}
export default SvgAdministrativeDetails;